import { useRef } from 'react';
import { t } from '@lingui/core/macro';
import { Box, IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useHistory } from 'react-router-dom';
import { useMount } from 'react-use';
import { constructSearchURL } from 'app/domains/global-search/utils/constructSearchURL';
import { getSearchEntityLink } from 'app/domains/global-search/utils/getSearchEntityLink';
import { useUniversalSearch } from '../useUniversalSearch';
import { InputContainer, StyledSearchInput } from './styled';
export function SearchInput() {
    const { searchText, setSearchText, closeSearchPopup, focusIndex, setFocusIndex, data, modifiers } = useUniversalSearch();
    const history = useHistory();
    const inputRef = useRef(null);
    const { results } = data;
    const resultsLength = results.length;
    const handleChange = (event) => {
        setSearchText(event.target.value);
        setFocusIndex(null);
    };
    useMount(() => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
    const resetQuery = () => {
        var _a;
        setSearchText('');
        setFocusIndex(null);
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    const changeIndex = (type) => {
        if (focusIndex === null) {
            if (type === 'inc') {
                setFocusIndex(0);
            }
            else {
                setFocusIndex(resultsLength);
            }
            return;
        }
        if (focusIndex === 0 && type === 'dec') {
            setFocusIndex(null);
            return;
        }
        const incrementBy = type === 'inc' ? 1 : -1;
        const newIndex = (focusIndex + incrementBy) % (resultsLength + 1);
        setFocusIndex(newIndex);
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (focusIndex === null) {
                const searchUrl = constructSearchURL({
                    modifiers,
                    path: 'search',
                    query: searchText,
                });
                history.push(searchUrl);
            }
            else {
                const focusedEntity = results === null || results === void 0 ? void 0 : results[focusIndex];
                const { entityId, entityType } = focusedEntity || {};
                if (!entityId || !entityType) {
                    return;
                }
                const link = getSearchEntityLink(entityType, entityId);
                history.push(link);
            }
            closeSearchPopup();
            return;
        }
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            changeIndex('inc');
            return;
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault();
            changeIndex('dec');
        }
    };
    return (<InputContainer>
      <StyledSearchInput ref={inputRef} name="advanced-search" value={searchText} autoComplete="off" spellCheck={false} onChange={handleChange} placeholder={t({
            message: 'Start typing...',
            comment: 'Placeholder for the universal search input.',
        })} onKeyDown={handleKeyDown}/>
      <Box gap="sm" alignItems="center">
        {Boolean(searchText.length) && (<IconButton $round appearance="ghost" size="small" aria-label={t({
                message: 'Clear search',
                comment: 'Universal search input - clear search button',
            })} onClick={resetQuery}>
            <Falcon icon="trash"/>
          </IconButton>)}
        <IconButton $round appearance="ghost" size="small" aria-label={t({
            message: 'Close search',
            comment: 'Universal search input - close search button',
        })} onClick={closeSearchPopup}>
          <Falcon icon="close"/>
        </IconButton>
      </Box>
    </InputContainer>);
}
